module.exports = __webpack_public_path__ + "h5/img/value.7469f35b.jpg";